//tipos
import { GetterTree } from "vuex";
import { State } from "@/typings/store";
import { StateDistribuidoresEnergia } from "@/typings/store/plugins/easyFirestore/distribuidoresEnergia";

const getters: GetterTree<StateDistribuidoresEnergia, State> = {
    get(state) {
        return state.all;
    },
    getArray(state) {
        return Object.values(state.all);
    },
};

const distribuidoresEnergia = {
    firestorePath: "dev/v1/distribuidoresEnergia",
    firestoreRefType: "collection",
    moduleName: "distribuidoresEnergia",
    statePropName: "all",
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: "%convertTimestamp%", // default
            updated_at: "%convertTimestamp%", // default
        },
    },
    state: {},
    getters,
    mutations: {},
    actions: {},
};

export default distribuidoresEnergia;
